import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function AdminCategoryRoute({ children }) {
  const current = useSelector((state) => state?.user?.data);
  let stored = {};
  try { stored = JSON.parse(localStorage.getItem("userData") || "{}").data || {}; } catch (_) {}
  const user = current?.userId ? current : stored;
  if (!localStorage.getItem("token")) return <Navigate to="/Login" replace />;
  return user.category === "ADMIN" ? children : <div className="main p-4" role="alert">Menu configuration is available only to users in the ADMIN category.</div>;
}
